import { forwardRef } from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

interface ICurrencyInputProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    value: string,
    name: string;
}

export const CurrencyInput = forwardRef<NumericFormatProps, ICurrencyInputProps>(function CurrencyInputCustom(props, ref) {
    const { onChange, value, ...other } = props;
    
    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            value={value}
            decimalScale={2}
            fixedDecimalScale
            thousandSeparator="."
            decimalSeparator=","
            valueIsNumericString
            placeholder="R$ 0,00"
            prefix="R$ "
        />
    );
},
);